import React from "react";
import About from "../parts/HomePage/About";
import Blog from "../parts/HomePage/Blog";
import CodingLogo from "../parts/HomePage/CodingLogo";
import Contact from "../parts/HomePage/Contact";
import Hero from "../parts/HomePage/Hero";
import Quote from "../parts/HomePage/Quote";
import Footer from "../parts/HomePage/Footer";
import Header from "../parts/HomePage/Header";
import useScrollAnchor from "../Hoock/UseScrollAncor";


function HomePage() {
  useScrollAnchor();
  return (
    <>
      <Header />
      <Hero />
      <CodingLogo/>
      <About/>
      <Blog/>
      <Quote/>
      <Contact/>  
      <Footer/>
      {/* <a href="afei" className="w-14 h-14 flex justify-center items-start bg-primary rounded-full p-4 fixed z-[9999] bottom-4 right-4 text-center text-2xl"><span className="mb-2">&#11165;</span></a>    */}
    </>
  );  
}

export default HomePage;
